// QuickLinksSection.js
import React from 'react';
import { Link } from 'react-router-dom';
import contactImage from '../assets/quick-link-contact.jpg';
import servicesImage from '../assets/quick-link-services.jpg';
import applyImage from '../assets/quick-link-apply.jpg';

const QuickLinksSection = () => {
  const quickLinks = [
    {
      title: 'Contact Us',
      image: contactImage,
      link: '/contact',
      subtitle: null
    },
    {
      title: 'Our Services',
      image: servicesImage,
      link: '/services/personal-care',
      subtitle: null
    },
    {
      title: 'Apply Today',
      image: applyImage,
      link: '/careers',
      subtitle: 'We are always looking for talented caregivers to join our team!'
    }
  ];

  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-gray-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 text-center mb-12">
          Quick Links
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {quickLinks.map((item, index) => (
            <Link
              key={index}
              to={item.link}
              className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="relative h-80">
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-50 transition-all duration-300"></div>
                
                {/* Content */}
                <div className="absolute inset-0 flex flex-col justify-end p-6 text-white">
                  <h3 className="text-2xl md:text-3xl font-bold mb-2">
                    {item.title}
                  </h3>
                  {item.subtitle && (
                    <p className="text-sm font-light">
                      {item.subtitle}
                    </p>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickLinksSection;
